import { render, staticRenderFns } from "./PopupDataEditNotification.vue?vue&type=template&id=07c79fce&scoped=true&"
import script from "./PopupDataEditNotification.vue?vue&type=script&lang=js&"
export * from "./PopupDataEditNotification.vue?vue&type=script&lang=js&"
import style0 from "./PopupDataEditNotification.vue?vue&type=style&index=0&id=07c79fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c79fce",
  null
  
)

export default component.exports